module.exports = __webpack_public_path__ + "static/ptpro_screen-24c8379d5e8c6e340dcaf3eb9506ab22.jpg";